/** React Router v7 future flags — silences deprecation warnings and matches upcoming defaults. */
export const ROUTER_FUTURE = {
  v7_startTransition: true,
  v7_relativeSplatPath: true,
} as const;
